import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './list-header.module.scss';

const ListHeader = ({href, text}) => (
  <div className={styles.ListHeader}>
    <h2 className="is-size-3">{text}</h2>
    <a className={classNames('is-size-7', styles.ListHeader__link)} href={href}>
      View all
    </a>
  </div>
);

ListHeader.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default ListHeader;



// WEBPACK FOOTER //
// ./src/components/ListHeader.js